import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router-dom';
import MlxDialog from '../../../../components/common/MlxDialog/MlxDialog';
import { useTranslation } from '../../../../hooks/useTranslation';
import { routes } from '../../../../routes/allRoutes';
import {
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_CONFIRM_TITLE,
    CANCEL_SUBSCRIPTION_BULLET_1,
    CANCEL_SUBSCRIPTION_BULLET_2,
    CANCEL_SUBSCRIPTION_BULLET_3,
    KEEP_SUBSCRIPTION,
    GO_TO_ALL_PLANS,
} from '../../../../constants/strings';

const languageTexts = {
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_CONFIRM_TITLE,
    CANCEL_SUBSCRIPTION_BULLET_1,
    CANCEL_SUBSCRIPTION_BULLET_2,
    CANCEL_SUBSCRIPTION_BULLET_3,
    KEEP_SUBSCRIPTION,
    GO_TO_ALL_PLANS,
};

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
};

const CancelSubscriptionModal = ({ visible, onHide, onConfirm }: Readonly<Props>) => {
    const navigate = useNavigate();
    const translatedText = useTranslation(languageTexts, 'none');
    const [confirmText, setConfirmText] = useState('');

    const handleHide = () => {
        setConfirmText('');
        onHide();
    };

    const isConfirmed = confirmText.toLowerCase() === 'cancel';

    return (
        <MlxDialog
            visible={visible}
            onHide={handleHide}
            header={
                <span>
                    <i className="ri-error-warning-line" style={{ marginRight: '0.5rem', color: '#e53935' }} />
                    {translatedText.CANCEL_SUBSCRIPTION_CONFIRM_TITLE || CANCEL_SUBSCRIPTION_CONFIRM_TITLE}
                </span>
            }
            style={{ maxWidth: '36rem', width: '90%' }}
        >
            <div className="cancel-confirm-dialog-body">
                <ul className="cancel-confirm-bullets">
                    <li>
                        <i className="ri-information-line" />
                        <span>{translatedText.CANCEL_SUBSCRIPTION_BULLET_1 || CANCEL_SUBSCRIPTION_BULLET_1}</span>
                    </li>
                    <li>
                        <i className="ri-alert-line" />
                        <span>{translatedText.CANCEL_SUBSCRIPTION_BULLET_2 || CANCEL_SUBSCRIPTION_BULLET_2}</span>
                    </li>
                    <li>
                        <i className="ri-refresh-line" />
                        <span>{translatedText.CANCEL_SUBSCRIPTION_BULLET_3 || CANCEL_SUBSCRIPTION_BULLET_3}</span>
                    </li>
                </ul>
                <div className="cancel-confirm-input">
                    <label htmlFor="cancel-confirm-text" className="cancel-confirm-label">
                        Type <strong>cancel</strong> to confirm
                    </label>
                    <InputText
                        id="cancel-confirm-text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        className="cancel-confirm-textbox"
                    />
                </div>
                <div className="cancel-confirm-actions">
                    <Button
                        label={translatedText.KEEP_SUBSCRIPTION || KEEP_SUBSCRIPTION}
                        className="p-button-text keep-subscription-btn"
                        onClick={handleHide}
                    />
                    <Button
                        label={translatedText.GO_TO_ALL_PLANS || GO_TO_ALL_PLANS}
                        className="go-to-plans-btn"
                        outlined
                        icon="ri-arrow-right-line"
                        iconPos="right"
                        onClick={() => {
                            handleHide();
                            navigate(`${routes.orgSubscriptions}?tab=all`);
                        }}
                    />
                    <Button
                        label={translatedText.CANCEL_SUBSCRIPTION || CANCEL_SUBSCRIPTION}
                        className="p-button-danger confirm-cancel-btn"
                        icon="ri-close-line"
                        disabled={!isConfirmed}
                        onClick={() => {
                            handleHide();
                            onConfirm();
                        }}
                    />
                </div>
            </div>
        </MlxDialog>
    );
};

export default CancelSubscriptionModal;
